import { gql } from "gql";

export const SAVE_TASK = gql(/* GraphQL */ `
  mutation SaveTask($task: TaskInput!) {
    saveTask(task: $task) {
      id
      name {
        value
      }
      description {
        value
      }
      parentTask {
        ... on TaskDto {
          id
        }
        ... on Hidden {
          ...Hidden
        }
      }
      project {
        id
      }
      ...TaskCompletionState
      reminder {
        minutesBefore
        nextRemindAt
      }
      person {
        ... on PersonDto {
          id
        }
        ... on Hidden {
          ...Hidden
        }
      }
      priority {
        id
      }
      attachments {
        id
      }
    }
  }
`);
